import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
// simport { TourListService } from 'src/services/tour-list.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: false,
})
export class HomeComponent implements OnInit {
  pageHeader = {
    title: 'Todas as soluções em um só lugar',
    style: '',
  };

  categoryListConhecimentos = {
    categories: [
      {
        url: 'Contatos',
        icone: 'fa-user',
        titulo: 'Contatos',
        cor: 'red',
      },
      {
        url: 'Segmentações',
        icone: 'fa-user',
        titulo: 'Segmentações de Lista',
        cor: 'red',
      },
      {
        url: 'CRM',
        icone: 'fa-user',
        titulo: 'CRM',
        cor: 'red',
      },
      {
        url: 'Integrações, Webhooks e API',
        icone: 'fa-user',
        titulo: 'Integrações, Webhooks e API',
        cor: 'red',
      },
      {
        url: 'Formulários e Landing Pages',
        icone: 'fa-user',
        titulo: 'Formulários e Landing Pages',
        cor: 'red',
      },
      {
        url: 'Pop-ups',
        icone: 'fa-user',
        titulo: 'Pop-ups',
        cor: 'red',
      },
      {
        url: 'Envios',
        icone: 'fa-user',
        titulo: 'Envios',
        cor: 'blue',
      },
      {
        url: 'Editores',
        icone: 'fa-user',
        titulo: 'Editores',
        cor: 'blue',
      },
      {
        url: 'Teste AB',
        icone: 'fa-user',
        titulo: 'Teste AB',
        cor: 'blue',
      },
      {
        url: 'Relatórios',
        icone: 'fa-user',
        titulo: 'Relatórios',
        cor: 'blue',
      },
      {
        url: 'Abandono de Carrinho',
        icone: 'fa-user',
        titulo: 'Abandono de Carrinho',
        cor: 'blue',
      },
      {
        url: 'Automações',
        icone: 'fa-user',
        titulo: 'Automações',
        cor: 'blue',
      },
      {
        url: 'WhatsApp',
        icone: 'fa-user',
        titulo: 'WhatsApp',
        cor: 'blue',
      },
      {
        url: 'SMS',
        icone: 'fa-user',
        titulo: 'SMS',
        cor: 'blue',
      },
      {
        url: 'IA',
        icone: 'fa-user',
        titulo: 'IA',
        cor: 'blue',
      },
      {
        url: 'Configurações',
        icone: 'fa-user',
        titulo: 'Configurações',
        cor: 'orange',
      },
      {
        url: 'Usuários e Permissões',
        icone: 'fa-user',
        titulo: 'Usuários e Permissões',
        cor: 'orange',
      },
      {
        url: 'Área Minha Conta',
        icone: 'fa-user',
        titulo: 'Área Minha Conta',
        cor: 'orange',
      },
    ],
  };

  sectionConhecimentos = {
    title: 'Área de Conhecimento',
    subtitle: 'Potencialize seus resultados com a Dinamize acessando tutoriais completos e dicas práticas',
    categoryList: this.categoryListConhecimentos,
  };

  // tourList = {
    // title: 'Soluções Guiadas',
    // tours: [],
  // };

  constructor(
    // private tourListService: TourListService,
    private viewportScroller: ViewportScroller,
  ) {}

  ngOnInit() {
    // this.getTourList();
    setTimeout(() => {
      this.viewportScroller.scrollToPosition([0, 0]);
    }, 0);
  }

  // getTourList() {
  // this.tourListService.getTourList().subscribe((res) => {
    // this.tourList.tours = res.filter((tour) =>
      // tour.name?.toLowerCase().includes('automation')
    // );
  // });
// }
}
